module.exports = __webpack_public_path__ + "img/ic-arrow-up-orange.b202e3f1.svg";